import React from 'react';
import styled from 'styled-components';
import {
  faEnvelope,
  faExternalLinkSquareAlt,
  faMapMarkerAlt,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { Icon } from './basic';
import LinkOut from './LinkOut';
import { colors } from '../constants';

const Wrapper = styled.div`
  padding-bottom: 12px;
`;

const TrimmedWrapper = styled(Wrapper)`
  @media not print {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const icons = {
  phone: faPhone,
  email: faEnvelope,
  address: faMapMarkerAlt,
  link: faExternalLinkSquareAlt,
};

function getIcon(type) {
  const faIcon = icons[type];
  return faIcon ? (
    <Icon icon={faIcon} color={colors.secondaryDark} />
  ) : null;
}

function getRenderValue(value, type) {
  switch (type) {
    case 'email':
      return <a href={`mailto:${value}`}>{value}</a>;

    case 'phone':
      return <a href={`tel:${value}`}>{value}</a>;

    case 'link':
      return (
        <LinkOut to={value}>
          {value.replace(/^https?:\/\//, '')}
        </LinkOut>
      );

    default:
      return value;
  }
}

function ContactInfoRow({ value, info, type }) {
  const renderValue = getRenderValue(value, type);

  const WrapperComponent =
    type === 'link' ? TrimmedWrapper : Wrapper;

  return (
    <WrapperComponent>
      {getIcon(type)}
      {info ? (
        <>
          {renderValue}
          {` (${info})`}
        </>
      ) : (
        renderValue
      )}
    </WrapperComponent>
  );
}

export default ContactInfoRow;
